export const NULL_MARKER = 0x00;

export const NUMBER_MARKER_BY_WIDTH = {
  1: 0x11,
  2: 0x12,
  4: 0x14,
} as const;

export const STRING_MARKER = 0x20;

export const MIXED_ARRAY_MARKER = 0x38;

export const NUMBER_ARRAY_MARKER_BY_WIDTH = {
  1: 0x31,
  2: 0x32,
  4: 0x34,
} as const;

export const RECORD_MARKER = 0x40;
